import { useState, useEffect } from "react"
import PropTypes from "prop-types"

const useTable = (data, page, pageSize) => {
    const [range, setRange] = useState([])
    const [slice, setSlice] = useState([])

    const getRange = (data, pageSize) => {
        const nbOfPages = Math.ceil(data.length / pageSize)
        let pages = []
        for (let i = 1; i <= nbOfPages; i++) {
            pages.push(i)
        }
        return pages
    }

    const sliceData = (data, page, pageSize) => (
        data.slice((page - 1) * pageSize, page * pageSize)
    )

    useEffect(() => {
        const pages = getRange(data, pageSize)
        const dataSlice = sliceData(data, page, pageSize)
        setRange([...pages])
        setSlice([...dataSlice])
    }, [data, page, pageSize, setRange, setSlice])

    return { slice, range }
}

useTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.array),
    page: PropTypes.number,
    pageSize: PropTypes.number
}

export default useTable